import { Component, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { AuthTokenFacade } from 'src/app/modules/auth/application/auth-token.facade';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {
  loading = false;
  title = 'angu-res';
  constructor(public router: Router, private authTokenFacade: AuthTokenFacade) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationStart) {
        this.loading = true;
      }
      if (
        ev instanceof NavigationEnd ||
        ev instanceof NavigationCancel ||
        ev instanceof NavigationError
      ) {
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {
    const uuid = this.authTokenFacade.getUuid();
    const token = this.authTokenFacade.getToken();

    if (token && uuid) {
      const uuid = this.authTokenFacade.getUuid();
      const data = this.authTokenFacade.getDataAudit(uuid);
              data.subscribe((auditData) => {
                this.authTokenFacade.fetchAudit(auditData).subscribe({
                  next: (response) => {
                    console.log(
                      'Auditoria de acceso registrado exitosamente:',
                      response
                    );
                  },
                  error: (error) => {
                    console.error(
                      'Error al registra auditoria de acceso:',
                      error
                    );
                  },
                });
              });
    } else {
      if (!uuid || uuid === '') {
        this.authTokenFacade.fetchUuid().subscribe({
          next: (resp: any) => {
            if (token && resp) {
              const uuid = this.authTokenFacade.getUuid();

              const data = this.authTokenFacade.getDataAudit(uuid);
              data.subscribe((auditData) => {
                this.authTokenFacade.fetchAudit(auditData).subscribe({
                  next: (response) => {
                    console.log(
                      'Auditoria de acceso registrado exitosamente:',
                      response
                    );
                  },
                  error: (error) => {
                    console.error(
                      'Error al registra auditoria de acceso:',
                      error
                    );
                  },
                });
              });
            } else if (!token && resp) {
              this.authTokenFacade.getTokenKonnect();
            }
          },
        });
      }
    }
  }

  submit(event: any) {
    console.log('credit card ', event);
  }
}



